import queryString, { StringifiableRecord } from 'query-string';
import { forEachObjIndexed, isEmpty, pickBy } from 'ramda';

const appendUrlArguments = (url: string, parameters?: object): string => {
  if (parameters && !isEmpty(parameters)) {
    const cleanedArguments = pickBy<object, StringifiableRecord>(
      (value) => value !== '',
      parameters
    );
    const urlArguments = queryString.stringify(cleanedArguments);
    if (urlArguments) {
      return `${url}?${urlArguments}`;
    }
  }

  return url;
};

const processFormattedString = <T extends string>(value: T): T => value.replaceAll(/%/gi, '') as T;

const processFormattedObject = <P>(body: P): P => {
  const bodyFormatted = body;
  forEachObjIndexed((value, key) => {
    if (typeof value === 'string') {
      bodyFormatted[key] = processFormattedString(value);
    } else if (typeof body === 'object') {
      bodyFormatted[key] = processFormattedObject(value);
    }
  }, bodyFormatted);
  return bodyFormatted;
};

// F5 is blocking % sign in bodies, so for that reason we never send it to the server.
const securityParser = <P>(body: P): P => processFormattedObject(body);

export { appendUrlArguments as appendUrlArgs, securityParser };
